// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/gem.js';

import { paths } from '../generated/gem';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('gem', Original, paths);
